export function Button({ children, tone = "primary", className = "", ...props }) {
	return (
		<button className={`button button--${tone} ${className}`} {...props}>
			{children}
		</button>
	);
}
